var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconsair(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.612,
    height: 15.311,
    viewBox: "0 0 14.612 15.311",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_sair",
    "data-name": "icon sair",
    transform: "translate(18576.95 19721.396)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1459",
    "data-name": "Caminho 1459",
    d: "M59.936,36.742v-.184a.075.075,0,0,0-.02-.061h0c0-.02-.02-.041-.041-.061a155.222,155.222,0,0,1-.041-.041l-2.169-2.947a.424.424,0,0,0-.675.512l1.7,2.251H51.73a.43.43,0,0,0,0,.859h6.978l-1.739,2.394a.411.411,0,0,0,.1.593.393.393,0,0,0,.246.082.4.4,0,0,0,.348-.184l2.21-3.07h0c.02-.02.02-.041.041-.061h0V36.8A.075.075,0,0,0,59.936,36.742Z",
    transform: "translate(-18622.523 -19750.449)",
    fill: "#005288",
    stroke: "#005288",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1460",
    "data-name": "Caminho 1460",
    d: "M28.461,18.911h-8.78a.354.354,0,0,1-.382-.34V4.44a.354.354,0,0,1,.382-.34h8.761a.354.354,0,0,1,.382.34V8.033a.384.384,0,0,1-.763,0V4.78h-8V18.231H28.08v-3.27a.384.384,0,0,1,.763,0v3.61A.365.365,0,0,1,28.461,18.911Z",
    transform: "translate(-18596 -19725.246)",
    fill: "#005288",
    stroke: "#005289",
    strokeWidth: 0.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsair);
export default __webpack_public_path__ + "static/media/icon sair.7d12f8454a6f0546b9b57465e17ebb2b.svg";
export { ForwardRef as ReactComponent };